import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'

export default window.customElements.define(
  'notification-center',
  class extends CustomElement {
    constructor() {
      super()
    }

    connectedCallback() {
      super.connectedCallback()

      this.stack = []

      Emitter.on('cookie-ready', this.onCookieReady.bind(this))
      Emitter.on('notification-close', this.onNotificationClose.bind(this))
      Emitter.on('notification:stack', this.onStackNotification.bind(this))
    }

    disconnectedCallback() {
      super.disconnectedCallback()
    }

    onCookieReady({ accepted }) {
      // this.stack = [...this.querySelectorAll(`notification-simple ${accepted ? '': ', notification-cookie'}`)]

      if (accepted) {
        const cookieNotificationIndex = this.stack.findIndex(
          ({ notification }) => notification.isCookie
        )
        if (cookieNotificationIndex !== -1) {
          this.stack.splice(cookieNotificationIndex, 1)
        }
      }

      setTimeout(this.show.bind(this), 1000)
    }

    onStackNotification({ notification, order }) {
      const alreadyStacked =
        this.stack.findIndex(
          ({ notification: stacked }) =>
            notification.dataset.id == stacked.dataset.id
        ) != -1
      if (alreadyStacked) return
      this.stack.push({ notification, order })
      this.stack.sort((a, b) => a.order - b.order)

      requestAnimationFrame(() => {
        this.appended && this.appendChild(notification)
      })
    }

    onNotificationClose(closedNotification) {
      this.stack = this.stack.filter(function ({ notification }) {
        return notification !== closedNotification
      })
      this.show()
    }

    appendNotifications() {
      this.stack.forEach(({ notification }) => {
        this.appendChild(notification)
      })
      this.appended = true
    }

    show() {
      if (!this.appended) this.appendNotifications()
      // only show 2 at a time
      const toShow = this.stack.slice(0, 2)
      toShow.forEach(({ notification }, i) => {
        setTimeout(() => {
          notification.show()
        }, i * 200)
      })
    }
  }
)
